import React, { useEffect, useState, useContext } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import UserContext from "../context/UserContext";
import FundStripe from "./FundStripe";
import { api } from "../utils/apiHelper";
import "../styles/Fundraiser.css";

const stripePromise = loadStripe("pk_live_51Rce3SAiBftvH423MIGBNy4l080OCs812VSiItIzcy2zZAc5zxBFcuU8fcp9Y0uJumOMygGwkaxnmKV4aTbHaeh200Gp46JiDc");

const Fundraiser = () => {
  const { authUser } = useContext(UserContext);
  const [popCustom, setPopCustom] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(true);

   const images = {
    liveAction: "live action.png",
    marquee: "live action lights.png"
  };


  useEffect(() => {
    const fetchPopCustom = async () => {
      try {
        const res = await api("/get-active-popcustom", "GET");
        if (res?.activePopCustom) {
          setPopCustom(res.activePopCustom);
        }
      } catch (err) {
        console.error("Error fetching active PopCustom:", err);
      }
    };

    fetchPopCustom();
  }, []);

  return (
    <div className="fundraiser-container">
      <h1 className="member">Donate and Become an Action Star Member</h1>
       <div>
             <img src={images.marquee} className="marquee" alt="marquee"/>
          </div>

  {popCustom && (
        <div className="fundraiser-popcustom">
          <h1 style={{ fontFamily: popCustom.headerStyle || "inherit" }}>
            {popCustom.header}
          </h1>

          <div style={{ fontFamily: popCustom.paragraph?.style || "inherit" }}>
            <p>
              {isCollapsed
                ? `${popCustom.paragraph?.text.slice(0, 100)}...`
                : popCustom.paragraph?.text}
            </p>
            <button
              className="toggle-button"
              onClick={() => setIsCollapsed(!isCollapsed)}
            >
              {isCollapsed ? "Read More" : "Show Less"}
            </button>

          </div>
           <div className="fundraiser-payment">
            <Elements stripe={stripePromise}>
              <FundStripe authUser={authUser} />
            </Elements>
          </div>
    
             <img
              className="live-action"
              src={images.liveAction}
              alt="Live Action"
            />

             <img
                src={popCustom.imageUrl}
                alt={popCustom.header}
                className="fundraiser-popcustom-image"
              />

            <ul className="line-items">
        <li>• 2x liveU solo - $1,990</li>
        <li>• 2x usb modem –  $278 </li>
        <li>• 2x external battery Power Oak – $264</li>
        <li>• 2x camera sony as300 bullet  - $596</li>
        <li>• 2x Live U backpack - $590</li>
      </ul>

        </div>
      )}
    </div>
  );
};

export default Fundraiser;
